import mitt from 'mitt'
import type { Events } from 'EventBus'

export default defineNuxtPlugin(() => {
  // @ts-expect-error disabled because use Interfaces, mitt accept Type
  const emitter = mitt<Events>()
  return {
    provide: {
      bus: {
        $on: emitter.on,
        $off: emitter.off,
        $emit: emitter.emit,
      },
    },
  }
})
